import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useCloseMenu } from '../../contexts/MenusContext';

import Menu from './Menu';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/menus/mobile.module.scss';

const propTypes = {
    items: AppPropTypes.menuItems,
    className: PropTypes.string,
};

const defaultProps = {
    items: null,
    className: null,
};

const MobileMenu = ({ items, className }) => {
    const onClick = useCloseMenu();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Menu
                className={styles.menu}
                itemClassName={styles.item}
                activeItemClassName={styles.active}
                items={items}
                onClick={onClick}
            />
        </div>
    );
};
MobileMenu.propTypes = propTypes;
MobileMenu.defaultProps = defaultProps;

export default MobileMenu;
